module.exports = __webpack_public_path__ + "img/red_047.054adfd7.png";